const mockHost: string = '__MOCK_HOST__';
const location: string = window?.location?.host ?? '';

export const pwaRequestHeaders =
    // mockHost can be the string 'undefined' due to replacing the value
    {
        'x-forwarded-host': mockHost !== 'undefined' ? mockHost : location,
    };
